import React, { useState } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { registerEditor } from "../../apis/apiList/authApi";
import { useMessage } from "../../context/MessageContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 900,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

const initialForm = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  ratePerProject: "",
  phone: "",
  twitter: "",
  linkedin: "",
  profile_pic: null,
};

export default function AddEditorModal({ open, handleClose, onSubmit }) {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [dragOver, setDragOver] = useState(false);
  const [isAddingEditor, setAddingEditor] = useState(false);

  const { showMessage } = useMessage();

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "profile_pic") {
      const file = files?.[0];
      if (file && file.type.startsWith("image/")) {
        setForm((prev) => ({ ...prev, profile_pic: file }));
      }
    } else if (name === "ratePerProject") {
      const numericValue = value.replace(/\D/g, "");
      setForm((prev) => ({ ...prev, [name]: numericValue }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validate = () => {
    let temp = {};
    temp.firstName = form.firstName ? "" : "First name is required";
    temp.lastName = form.lastName ? "" : "Last name is required";
    temp.email = /^\S+@\S+\.\S+$/.test(form.email)
      ? ""
      : "Valid email is required";
    temp.password =
      form.password.length >= 3 ? "" : "Password must be at least 3 characters";
    temp.ratePerProject = form.ratePerProject ? "" : "Rate is required";
    temp.phone =
      /^(\+)?[0-9()\-\s]+$/.test(form.phone) && form.phone.length >= 7
        ? ""
        : "Enter a valid phone";
    // temp.twitter =
    //   form.twitter && !/^https?:\/\/.+$/.test(form.twitter)
    //     ? "Enter valid URL"
    //     : "";
    // temp.linkedin =
    //   form.linkedin && !/^https?:\/\/.+$/.test(form.linkedin)
    //     ? "Enter valid URL"
    //     : "";

    setErrors(temp);
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = async () => {
    if (validate()) {
        setAddingEditor(true);
        try {
            const response = await registerEditor(form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log("response", response);
            onSubmit(response.data);
            showMessage('Editor Added Successfully...!!', 'success')
            handleClose();
            setForm(initialForm);
            setAddingEditor(false);
        } catch (error) {
            console.log("error in add editor", error);
            showMessage(error?.response?.data?.message || 'Something went wrong', "error");
            setAddingEditor(false);
        }
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);

    const file = e.dataTransfer.files?.[0];
    if (file && file.type.startsWith("image/")) {
      setForm((prev) => ({ ...prev, profile_pic: file }));
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Add Editor</Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>

        <Grid container spacing={2} mt={1}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="First Name"
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
              error={!!errors.firstName}
              helperText={errors.firstName}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Last Name"
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              error={!!errors.lastName}
              helperText={errors.lastName}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={form.email}
              onChange={handleChange}
              error={!!errors.email}
              helperText={errors.email}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              error={!!errors.password}
              helperText={errors.password}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Phone"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              error={!!errors.phone}
              helperText={errors.phone}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Rate Per Project ($)"
              name="ratePerProject"
              value={form.ratePerProject}
              onChange={handleChange}
              error={!!errors.ratePerProject}
              helperText={errors.ratePerProject}
              inputProps={{ inputMode: "numeric" }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Twitter URL"
              name="twitter"
              value={form.twitter}
              onChange={handleChange}
              //   error={!!errors.twitter}
              //   helperText={errors.twitter}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="LinkedIn URL"
              name="linkedin"
              value={form.linkedin}
              onChange={handleChange}
              //   error={!!errors.linkedin}
              //   helperText={errors.linkedin}
            />
          </Grid>

          <Grid item xs={12}>
            <Box
              onDragOver={(e) => {
                e.preventDefault();
                setDragOver(true);
              }}
              onDragLeave={() => setDragOver(false)}
              onDrop={handleDrop}
              sx={{
                border: "2px dashed #999",
                borderRadius: 2,
                p: 2,
                textAlign: "center",
                backgroundColor: dragOver ? "#f0f0f0" : "#fafafa",
                cursor: "pointer",
              }}
              onClick={() => document.getElementById("profilePicInput").click()}
            >
              <Typography>
                {form.profile_pic
                  ? `Selected: ${form.profile_pic.name}`
                  : "Drag & drop profile picture here, or click to select"}
              </Typography>
              <input
                id="profilePicInput"
                type="file"
                accept="image/*"
                name="profile_pic"
                hidden
                onChange={handleChange}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button onClick={handleClose} variant="outlined">
                Cancel
              </Button>
              <Button variant="contained" onClick={handleSubmit} disabled={isAddingEditor}>
                { isAddingEditor ? 'Adding Editor...' : 'Add Editor' }
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
